import { useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import OpeningHoursList from "@/components/opening-hours-list";
import { openingHoursQueryOptions } from "@/lib/shifts";
import { websiteConfigQueryOptions } from "@/lib/website-config";

export default function Footer() {
  const { t } = useTranslation("translation");

  const websiteConfigQuery = useSuspenseQuery(websiteConfigQueryOptions());
  const openingHoursQuery = useSuspenseQuery(openingHoursQueryOptions());

  return (
    <footer id="contact-info" className="border-t">
      <div className="container mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
        <div>
          <h3 className="text-lg font-semibold">{t("Footer.opening_hours")}</h3>
          <OpeningHoursList
            className="mt-3"
            openingHoursData={openingHoursQuery.data?.data ?? {}}
          />
        </div>
        <div>
          <h3 className="text-lg font-semibold">{t("Footer.contact")}</h3>
          <address className="mt-3 not-italic text-sm text-muted-foreground space-y-1">
            <p className="font-medium text-foreground">
              {websiteConfigQuery.data.companyName}
            </p>
            <p>
              {`${websiteConfigQuery.data.companyAddress.streetName} ${websiteConfigQuery.data.companyAddress.streetNumber}`}
            </p>
            <p>
              {`${websiteConfigQuery.data.companyAddress.zipCode} ${websiteConfigQuery.data.companyAddress.city}`}
            </p>
            {websiteConfigQuery.data.companyPhoneNumber && (
              <p>
                <a href={`tel:${websiteConfigQuery.data.companyPhoneNumber}`}>
                  {websiteConfigQuery.data.companyPhoneNumber}
                </a>
              </p>
            )}
          </address>
        </div>
      </div>
      <div className="border-t py-4 text-center text-sm text-muted-foreground">
        © {new Date().getFullYear()} {websiteConfigQuery.data.companyName}.{" "}
        {t("Footer.all_rights_reserved")}
      </div>
    </footer>
  );
}
